function formatUrl(url, params) {
  let operater = url.indexOf('?') === -1 ? '?' : '&';
  const { hasOwnProperty } = Object.prototype;
  if (params) {
    for (const key in params) {
      if (hasOwnProperty.call(params, key)) {
        url += `${operater + key}=${params[key]}`;
        operater = '&';
      }
    }
  }
  return url;
}
// 用来缓存postMsg过来的视频状态信息
let msgData = {};
// 接收消息
function receiveMsg(cb, target = window) {
  const listener = function (e) {
    const postMsg = e.data;
    if (postMsg) {
      try {
        msgData = JSON.parse(postMsg);
        console.log('[receiveMsg]', msgData);
      } catch (ex) {
        console.warn(`PostMsg Parse Error ${postMsg}`, ex);
        return;
      }
      typeof cb === 'function' ? cb(msgData) : '';
    } else {
      return;
    }
  };
  target.addEventListener('message', listener);
}
function getMobileSize() {
  const doc = document.documentElement || document.body;
  const w = doc.clientWidth;
  const h = doc.clientHeight;
  const { scrollTop } = doc;
  return {
    w,
    h,
    scrollTop,
  };
}
// State统一定时器
const stateTimer = (function () {
  const stateTimers = [];
  function make(func, options) {
    clear(options.id);
    stateTimers[options.id] = setTimeout(func, options.delay);
  }
  function clear(id) {
    stateTimers[id] && clearTimeout(stateTimers[id]);
  }
  return {
    make,
    clear,
  };
}());
// 环境判断
const isOa = /^oa.*.qq.com/.test(location.host);
const isGray = /chat.*?-gray/.test(location.href);
const ua = navigator.userAgent.toLowerCase();
const isSafari = /^((?!chrome|android).)*safari/.test(ua);
const isWXWork = ua.match(/wxwork/i) == 'wxwork';
const isWeixin = !isWXWork && ua.match(/micromessenger/i) == 'micromessenger';
const isMiniprogram = window.__wxjs_environment === 'miniprogram';
const miniprogramConfig = {
  // 测试环境小程序
  oa: {
    appId: 'wx8b7354939f7b1230',
    originId: 'gh_80dc8192b287',
  },
  // 灰度环境小程序
  gray: {
    appId: 'wx3d4ff77c95ac42ee',
    originId: 'gh_1b3528ea7c6e',
  },
  // 线上环境小程序
  ol: {
    appId: 'wx76278ae97cfea8ce',
    originId: 'gh_97d7d14a21da',
  },
};
let miniProgramAppId = miniprogramConfig.ol.appId;
let miniProgramOriginId = miniprogramConfig.ol.originId;
if (isOa) {
  miniProgramAppId = miniprogramConfig.oa.appId;
  miniProgramOriginId = miniprogramConfig.oa.originId;
} else if (isGray) {
  miniProgramAppId = miniprogramConfig.gray.appId;
  miniProgramOriginId = miniprogramConfig.gray.originId;
}
// 是否QQ浏览器
const isQQBrowser = (function () {
  return /MQQBrowser/i.test(navigator.userAgent);
}());
function judgeIsWXBrowser() {
  const ua = navigator.userAgent.toLowerCase();
  return 'micromessenger' === ua.match(/MicroMessenger/i);
}
export {
  formatUrl,
  isOa,
  stateTimer,
  isSafari,
  isWeixin,
  isMiniprogram,
  miniProgramAppId,
  miniProgramOriginId,
  receiveMsg,
  getMobileSize,
  isQQBrowser,
  judgeIsWXBrowser,
};
